import {IUserTicketPrize} from "../../../firebase/topics/in-game-challenges/tickets-update/user-tickets-update-topic.model.interface";
import {IInGameTicketPrize} from "./in-game-ticket-prize-types";

export abstract class InGameTicketPrizeAbstract implements IInGameTicketPrize, IUserTicketPrize {
    constructor(protected _prizeData: IUserTicketPrize) {}
    abstract prizeString(): string;
    toString(): string {
        return JSON.stringify(this._prizeData);
    }
    get prizeValue() {
        return this._prizeData.prizeValue;
    }
    get prizeType() {
        return this._prizeData.prizeType;
    }
    isEqual(p: IUserTicketPrize) {
        return this._prizeData.prizeType === p.prizeType && this._prizeData.prizeValue === p.prizeValue;
    }
}
